import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HostDinnerIntro.css";
import { useNavigate } from "react-router-dom";
import Header from '../../components/Header';

export default function HostDinnerIntro() {
    const navigate = useNavigate();

    return (
        <div className="container-fluid min-vh-100 d-flex flex-column p-0" style={{ background: 'none' }}>
            <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                <div className="card shadow-lg p-4 rounded-4 w-100" style={{ maxWidth: 700, background: '#fff' }}>
                    <div className="d-flex align-items-center mb-3" style={{ justifyContent: 'flex-end' }}>
                        <span role="img" aria-label="house" style={{ fontSize: 32, marginRight: 12 }}>🏠</span>
                        <span className="host-dinner-link mb-0" style={{ fontWeight: 600, color: "#15316b", marginLeft: 8, textAlign: "right", fontSize: '1.2rem' }}>Host a Dinner</span>
                    </div>
                    <h2 className="mb-3" style={{ fontWeight: 'bold', fontSize: '1.2rem', textAlign:"center" }}>Tell Us a Bit About Your Shabbat Dinner</h2>
                    <p className="mb-2" style={{ fontSize: '1rem', color: '#222', textAlign: "center" }}>
                        Thank you for being part of this – your hospitality means so much.
                    </p>
                    <p className="mb-4" style={{ fontWeight: 500, fontSize: '1rem', color: '#222', textAlign: "center" }}>
                        To get started, we'd love to hear a little about your Shabbat hosting experience. The more we know, the better we can connect you with guests who'll be a great fit.
                    </p>
                    <div className="d-flex justify-content-center">
                        <button
                            className="btn btn-warning px-4 py-2 rounded-pill fw-bold text-white"
                            style={{ background: '#ffb97a', border: 'none', marginTop: 80 }}
                            onClick={() => navigate('/HostDinnerAddress')}
                        >
                            Let's get started!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}